<template>
	<div>
		<a href="https://mp.weixin.qq.com/s/rAf24d_fOowbaTu9_HQBww">
			<firstsceenimage :imgobj='bigimage'></firstsceenimage>
		</a>

		<adword title="华为盘古大模型深度数据学习"
			subtitle="星链通过人工智能和数据挖掘领域的前沿技术，从国内外主流时尚平台及社交平台挖掘时尚素材。从时尚素材收集、流行趋势发现，到新款式研发、爆款商品预测，为品牌商与平台客户实现从趋势发现、设计师款式选择、样品制作、品牌选样到柔性订单生产的全链路闭环。"
			slotheight="570">
			<div class="" style="margin-top: 50px;">
				<div class="flexcenter">
					<div style="width: 240px;padding:  25px;">
						<img style="width: 85px;" src="../../static/全球时尚数据库ico.png">
						<div
							style="font-size: 16px;font-weight:bold;color: #333333;letter-spacing: 3px;font-family: Microsoft YaHei-Bold, Microsoft YaHei;">
							全球时尚数据库</div>
						<div style="color: #999999; font-size: 12px;margin-top: 9px;">覆盖全球4000000家不同行业下旺铺数据</div>
					</div>
					<div style="width: 240px;padding:  25px;">
						<img style="width: 85px;" src="../../static/大模型数据学习ico.png">
						<div
							style="font-size: 16px;font-weight: bold;color: #333333;letter-spacing: 3px;font-family: Microsoft YaHei-Bold, Microsoft YaHei;">
							大模型数据学习</div>
						<div style="color: #999999; font-size: 12px;margin-top: 9px;">华为盘古大模型亿级样品学习AI分析秒级反应</div>
					</div>
					<div style="width: 240px;padding:  25px;">
						<img style="width: 85px;" src="../../static/趋势解读，直达爆款ico.png">
						<div
							style="font-size: 16px;font-weight: bold;color: #333333;letter-spacing: 3px;font-family: Microsoft YaHei-Bold, Microsoft YaHei;">
							趋势解读，直达爆款</div>
						<div style="color: #999999; font-size: 12px;margin-top: 9px;">基于对行业、竞店、类目及属性的大数据分析，解读趋势，赋能电商
						</div>
					</div>
				</div>
				<img style="width: 90%;" src="../../static/模型流程图.png" />
			</div>
		</adword>


		<advideo v-if="isShowNavAD" style="color: white;" title="数据解构，AI流行趋势分析"
			subtitle="星链基于高品质的数据整合以及覆盖到SKU级的详尽数据，对行业、竞店、类目及属性进行大数据分析，解读趋势，赋能行业上下游。星链数据将以图像识别、数据挖掘、智能推荐等核心能力技术为基础，协助鞋服品牌解决选款难、爆品少、主观风险高、设计效率低等难题，以数据反哺设计，驱动新增长，重塑新生态。"
			:video="video" :subtitlestyle="subtitlestyle"> </advideo>


	</div>
</template>
<script>
import firstsceenimage from '../../components/firstsceenimage.vue'
import adword from '../../components/adword.vue'
import bigimage from '../../static/banner2.png'
import advideo from '../../components/advideo.vue'
import video from '../../assets/video/2.mp4'

export default {
	name: 'Proailiuxing',
	components: {
		firstsceenimage,
		adword,
		advideo,
	},
	data() {
		return {
			bigimage: bigimage,
			video: video,
			subtitlestyle: {

				opacity: '0.5',
			},
			isShowNavAD: false,
		}
	},
	mounted() {
		if (window.innerWidth < 1000) {
			this.isShowNavAD = false
		} else {
			this.isShowNavAD = true
		}



	},

}
</script>

<style>

</style>
